<template>
  <div class="game">
    <canvas class="game__view" ref="view" />
  </div>
</template>

<script>
import Application from './Application';

export default {
  name: 'VGame',

  data: () => ({
    application: undefined,
    answer: undefined,
    attachment: undefined,
    score: undefined,
  }),

  mounted() {
    this.application = new Application({
      view: this.$refs.view,
    }, (score) => {
      debugger;
      this.score = score;
      this.application.stop();

      this.end();
    });
  },

  methods: {
    end() {
      const { answer, attachment, score } = this;

      this.$emit('end', {
        answer,
        attachment,
        score,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.game {
  &__view {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
